import { render, staticRenderFns } from "./ClientSearchAreaRefund.vue?vue&type=template&id=a2bcfd0a&scoped=true&"
import script from "./ClientSearchAreaRefund.vue?vue&type=script&lang=js&"
export * from "./ClientSearchAreaRefund.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchAreaRefund.vue?vue&type=style&index=0&id=a2bcfd0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bcfd0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
